/**
 * ISO 3166-1 alpha-2 country codes used by MadHive's geo targeting system.
 * Reference: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 *
 * NOTE: These must match the format expected by protos/mad/geo.proto
 * (2-letter uppercase codes)
 */
export const COUNTRY_CODES = {
  UNITED_STATES: "US",
  CANADA: "CA",
  PUERTO_RICO: "PR"
} as const;

export type CountryCode = (typeof COUNTRY_CODES)[keyof typeof COUNTRY_CODES];

export interface CountryOption {
  code: CountryCode;
  name: string;
}

export const GEO_COUNTRY_CONFIG: Record<CountryCode, CountryOption> = {
  [COUNTRY_CODES.UNITED_STATES]: {
    code: COUNTRY_CODES.UNITED_STATES,
    name: "United States"
  },
  [COUNTRY_CODES.CANADA]: { code: COUNTRY_CODES.CANADA, name: "Canada" },
  [COUNTRY_CODES.PUERTO_RICO]: {
    code: COUNTRY_CODES.PUERTO_RICO,
    name: "Puerto Rico"
  }
};
